import { render, staticRenderFns } from "./EditSection.vue?vue&type=template&id=131d1a36&"
import script from "./EditSection.vue?vue&type=script&lang=js&"
export * from "./EditSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports